import { render, staticRenderFns } from "./TimeToMarketTableRow.vue?vue&type=template&id=31615be3&"
import script from "./TimeToMarketTableRow.vue?vue&type=script&lang=js&"
export * from "./TimeToMarketTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports